export default {
  floatingTopMenu: {
    openSettings: 'Nastavení',
    showAbout: 'Zobrazit obecné informace',
    about: 'O ORS',
    openrouteserviceAPI: 'Openrouteservice API',
    openrouteserviceForDisasters: 'Openrouteservice pro katastrofy',
    askOpenrouteservice: 'Ptejte se openrouteservice',
    settingsTooltip: 'Pokud chcete upravit nastavení aplikace a zobrazit další možnosti, klikněte zde.'
  }
}
